import React, { useEffect } from 'react'
import { Row, Col } from 'antd';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ContactSubmit = ({ t }) => {
    const lang = useSelector(state => state.language)
    useEffect(() => {
        const header = document.querySelector('.section-contact-header')
        header.style.display = 'none'
    })
    return (
        <Row justify="center">
            <Col xl={10} lg={10} md={13} sm={13} xs={18}>
                <Row justify="center">
                    <div className="contact-submit-box">
                        <Row justify="center">
                            <svg className="contact-submit-img" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M24 0C10.7664 0 0 10.7664 0 24C0 37.2336 10.7664 48 24 48C37.2336 48 48 37.2336 48 24C48 10.7664 37.2336 0 24 0ZM19.2024 34.5912L10.2912 25.6992L13.68 22.3008L19.1976 27.8088L31.9032 15.1032L35.2968 18.4968L19.2024 34.5912Z" fill="#27AE60" />
                            </svg>
                        </Row>
                        {
                            lang === 'cn' ? (
                                <>
                                    <p className="contact-submit-text">{t('contact_page_form.text_submit_box_cn')}</p>
                                    <p className="contact-back-text">{t('contact_page_form.text_submit_back_1')}<Link to="/portal" className="red-text">{t('contact_page_form.text_submit_link') + t('contact_page_form.text_submit_back_2')}</Link></p>
                                </>
                            ) : (
                                <>
                                    <p className="contact-submit-text">{t('contact_page_form.text_submit_box_1')}</p>
                                    <p className="contact-submit-text">{t('contact_page_form.text_submit_box_2')}</p>
                                    <p className="contact-submit-text">{t('contact_page_form.text_submit_box_3')}</p>
                                    <p className="contact-back-text">{t('contact_page_form.text_submit_back')} <Link to="/portal" className="red-text">{t('contact_page_form.text_submit_link')}</Link> </p>
                                </>
                            )
                        }
                    </div>
                </Row>
            </Col >
        </Row >
    )
}

export default translate()(ContactSubmit)
